import React from 'react';
import {
  TextareaAutosize as MaterialUiTextareaAutosize,
  TextareaAutosizeProps,
} from '@mui/material';
import { ISharedProps } from '../../tools/ISharedProps';

interface ITextareaAutosizeProps extends TextareaAutosizeProps, ISharedProps {}

export const TextareaAutosize = ({ ...props }: ITextareaAutosizeProps) => (
  <MaterialUiTextareaAutosize {...props} />
);
